import { registerSectionComponent } from '../../../config/sectionRegistry';
import DrawsHero from './DrawsHero';
import DrawsLiveNow from './DrawsLiveNow';
import DrawsUpcomingGrid from './DrawsUpcomingGrid';
import DrawsPastList from './DrawsPastList';
import DrawsCalendar from './DrawsCalendar';
import DrawsCta from './DrawsCta';

// Register draws sections
registerSectionComponent('draws_hero', DrawsHero, {
  category: 'hero',
  label: 'Draws Hero',
  description: 'Page hero with title and subtitle',
  supportedPages: ['draws'],
});

registerSectionComponent('draws_live_now', DrawsLiveNow, {
  category: 'promo',
  label: 'Draws Live Now',
  description: 'Current/active draw notification banner',
  supportedPages: ['draws'],
});

registerSectionComponent('draws_upcoming_grid', DrawsUpcomingGrid, {
  category: 'draws',
  label: 'Draws Upcoming Grid',
  description: 'Grid of scheduled upcoming draws',
  supportedPages: ['draws'],
});

registerSectionComponent('draws_past_list', DrawsPastList, {
  category: 'draws',
  label: 'Draws Past List',
  description: 'Past draws list with winner reveals',
  supportedPages: ['draws'],
});

registerSectionComponent('draws_calendar', DrawsCalendar, {
  category: 'draws',
  label: 'Draws Calendar',
  description: 'Calendar/schedule view with tab switcher',
  supportedPages: ['draws'],
});

registerSectionComponent('draws_cta', DrawsCta, {
  category: 'promo',
  label: 'Draws CTA',
  description: 'Purchase CTA / subscribe',
  supportedPages: ['draws'],
});

export {
  DrawsHero,
  DrawsLiveNow,
  DrawsUpcomingGrid,
  DrawsPastList,
  DrawsCalendar,
  DrawsCta,
};
